const radConfig = {
  allottement_status: false,
  currentUrl: "https://pacs.toprad.us/",
  previousVisitUrl: "https://medapps.medallcorp.in",
  baseUrl: "https://pacs.toprad.us/api/quickrad",
  baseUrlRadio: "https://pacs.toprad.us/api/quickrad/radio",
  radTitle: "AIkenist Technology Pvt. Ltd.",
  viewerURL: "https://pacs.toprad.us/aikenviewer/viewer/",
  viewer3DURL:"https://pacs.toprad.us/3daikenviewer/viewer?StudyInstanceUIDs=",
  viewerPET:"https://pacs.toprad.us/3daikenviewer/tmtv?StudyInstanceUIDs=",
  viewerSM:"https://pacs.toprad.us/3daikenviewer/microscopy?StudyInstanceUIDs=",  
  viewerSeg:"https://pacs.toprad.us/3daikenviewer/segmentation?StudyInstanceUIDs=",  
  viewerMultiple: "https://pacs.toprad.us/3daikenviewer/viewer?",
  viewerMultiplePet: "https://pacs.toprad.us/3daikenviewer/tmtv?",
  medDream:"https://pacs.toprad.us/?study=",
  thumbnailURL: "https://pacs.toprad.us/dicom-web/instances/",
  gifURL:
  "https://pacs.toprad.us/api/quickrad/general/convert-to-gif?series_ins=",
  dicomWeb: "https://pacs.toprad.us/dicom-web",
  weasisDicomWeb: "https://pacs.toprad.us/dicom-web",
  studyList: "https://pacs.toprad.us/dicom-web/studies",
  localViewer: "https://pacs.toprad.us/aikenviewer/local",
  client: "toprad",
  paymentComplete: true,
  version: "v2.0",
  radiAntPath: "C:\\xampp\\htdocs\\python\\input_scan\\tmp"
};

// ******************************************

localStorage.setItem("client", radConfig.client);

if (
  localStorage.getItem("showTAT") == "" ||
  localStorage.getItem("showTAT") == null
) {
  localStorage.setItem("showTAT", "false");
}
if (
  localStorage.getItem("studyTracker") == "" ||
  localStorage.getItem("studyTracker") == null
) {
  localStorage.setItem("studyTracker", "false");
}

export default radConfig;
